import { defaultWagmiConfig } from '@web3modal/wagmi/react/config';
import { base, baseSepolia } from 'wagmi/chains';

export const projectId = 'd2e1878d46c2002e2b0cead22fa4ca98';

const metadata = {
  name: 'Kojiru',
  description: 'AI-Powered Crypto Lending on Base',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://kojiru.com',
  icons: ['/logo192.png'],
};

const chains = [base, baseSepolia];

export const wagmiConfig = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  enableWalletConnect: true,
  enableInjected: true,
  enableEIP6963: true,
  enableCoinbase: true,
});
